var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeApproved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.788,
    height: 27.291,
    viewBox: "0 0 26.788 27.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12490",
    "data-name": "Group 12490",
    transform: "translate(-1493.898 -247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38024",
    "data-name": "Path 38024",
    d: "M4.271,211.106a.544.544,0,0,0,.546.546H19.488a4.5,4.5,0,0,1-.027-.546,6.345,6.345,0,0,1,4.989-6.2,11.128,11.128,0,0,0-4.967-4.017,7.094,7.094,0,0,1-8.351-.011,11.063,11.063,0,0,0-6.861,10.223Z",
    transform: "translate(1489.627 57.934)",
    fill: "#5ae286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38025",
    "data-name": "Path 38025",
    d: "M101.353,6.042a6.045,6.045,0,1,0-6.048,6.048,6.053,6.053,0,0,0,6.048-6.048Z",
    transform: "translate(1409.635 247)",
    fill: "#5ae286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38026",
    "data-name": "Path 38026",
    d: "M291.557,290.577a5.254,5.254,0,1,0-5.251,5.251,5.261,5.261,0,0,0,5.251-5.251Zm-2.79-1.048-2.864,2.864a.545.545,0,0,1-.772,0l-1.288-1.288a.546.546,0,0,1,.772-.772l.9.9L288,288.757a.546.546,0,1,1,.772.772Z",
    transform: "translate(1229.129 -21.537)",
    fill: "#5ae286"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeApproved);
export default __webpack_public_path__ + "static/media/DE-Approved.23bb21ed.svg";
export { ForwardRef as ReactComponent };